import React, { useEffect } from 'react';
import { useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { fetchAccounts } from "../../../../actions/mine_craft/accountsActions";
import { queryParams } from "../../../../helpers/UrlHelpers";

import Pagination from "../../../../componets/Pagination";
import Card from "../../../../componets/Card";
import AccountsList from "../../Accounts/_partials/_ListTable";

const LIMIT = 20;

const _Accounts = ({ deviceId }: { deviceId: number | undefined }) => {
  const dispatch       = useAppDispatch();
  const [searchParams] = useSearchParams();
  const currentPage    = queryParams.getInt(searchParams,'page') || 1;
  const count          = useAppSelector(state => state.mineCraft.accounts.count);

  useEffect(() => {
    if (!deviceId) {
      return;
    }

    const params: any = {
      limit: LIMIT,
      offset: (currentPage - 1) * LIMIT,
      device_id: deviceId
    };

    dispatch(fetchAccounts(params))
  }, [deviceId, currentPage, dispatch]);

  return (
    <Card>
      <h4 className='v-content-title'>Accounts</h4>
      <AccountsList />

      <Pagination total={count} size={LIMIT} />
    </Card>
  )
}

export default _Accounts;
